import React, { useState, useEffect } from 'react';
import axiosInstance from '../../axiosConfig.jsx';
import PageHeaderTile from '../ui/PageHeaderTile';
import { Trash2 } from 'lucide-react';
import DeletedInvoicesList from '../deleted-invoices/DeletedInvoicesList.js';

function DeletedPage() {
    const [deletedInvoices, setDeletedInvoices] = useState([]);
    const [page, setPage] = useState(0);
    const [size] = useState(20);
    const [hasMore, setHasMore] = useState(true);

    const fetchDeletedInvoices = (page, size) => {
        axiosInstance.get(`/api/invoices/deleted?page=${page}&size=${size}`)
            .then(response => response.data)
            .then(data => {
                if (data.length < size) {
                    setHasMore(false);
                }
                setDeletedInvoices(prevInvoices => [...prevInvoices, ...data]);
            })
            .catch(error => console.error('Error fetching invoices:', error));
    };

    const loadMore = () => {
        setPage(prevPage => prevPage + 1);
    };

    const handleRestoreDeletedInvoice = (invoiceId) => {
        axiosInstance.post(`/api/invoices/deleted/${invoiceId}`)
            .then(response => {
                console.log('Invoice restored:', response.data);
                setDeletedInvoices(prevInvoices => prevInvoices.filter(inv => inv.id !== invoiceId));
            })
            .catch(error => {
                alert('Error restoring invoice: ' + (error.response?.data?.error?.message || 'Unknown error'));
            });
    };

    useEffect(() => {
        fetchDeletedInvoices(page, size);
    }, [page, size]);

    return (
        <div className="w-full max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8 flex flex-col gap-8">
            <PageHeaderTile title="Изтрити фактури" icon={Trash2} />
            
            <DeletedInvoicesList
                invoices={deletedInvoices}
                handleRestoreDeletedInvoice={handleRestoreDeletedInvoice}
                loadMore={loadMore}
                hasMore={hasMore}
            />
        </div>
    );
}

export default DeletedPage;
